import { styled } from 'styled-components';

export const EditableContainer = styled.div`
  position: relative;
  &:hover .edit-icon {
    opacity: 1;
  }
`;

export const DisplayContainer = styled.div`
  cursor: pointer;
  padding: 4px 8px;
  background: #fff;
  border-radius: 4px;
  transition: all 0.2s ease;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const EditIcon = styled.div`
  opacity: 0;
  transition: opacity 0.2s ease;
  cursor: pointer;
  padding: 4px;
  border-radius: 2px;
`;
